// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const palafin_zero: PokeData = {
  "id": 964,
  "name": "palafin-zero",
  "height": 13,
  "weight": 602,
  "base_experience": 160,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "supersonic",
    "mist",
    "water-gun",
    "hydro-pump",
    "focus-energy",
    "charm",
    "encore",
    "focus-punch",
    "dive",
    "astonish",
    "aqua-tail",
    "aqua-jet",
    "double-hit",
    "acrobatics",
    "flip-turn",
    "wave-crash",
    "jet-punch"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "aqua-tail",
    "aqua-jet",
    "acrobatics",
    "rain-dance",
    "bubble-beam",
    "brine",
    "whirlpool",
    "aqua-cutter",
    "life-dew",
    "liquidation",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 504,
    "item": null,
    "species": [
      {
        "name": "finizen",
        "order": 933,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "palafin",
        "order": 934,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 963,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 158,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
